// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.new-account {
    max-width: 500px;
    margin: 0 auto;
    padding: var(--space-x2) 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.new-account__title {
    margin-bottom: var(--space);
    align-self: flex-start;
    text-align: left;
}
.new-account__text {
    align-self: flex-start;
    text-align: left;
}
.new-account__subtext {
    margin-bottom: var(--space-half);
    letter-spacing: 0.0025em;
    color: var(--primary-color);
    font-size: var(--font-small);
}
.new-account__methods {
    width: 100%;
}
.new-account__methods.social {
    display: flex;
    gap: var(--space-and-half);
}
.new-account__methods__method {
    margin: var(--space-and-half) 0;
}

.new-account__separator {
    margin: var(--space-x3) 0;
    width: 100%;
}

.new-account__form {
    margin-top: var(--space-x3);
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: var(--grid-gap);
}
.new-account__form .input-field {
    grid-column-start: 1;
    grid-column-end: 3;
}

.new-account__form .checkbox-field {
    grid-column-start: 1;
    grid-column-end: 3;
}

.new-account__form__field-first-half {
    grid-column-start: 1 !important;
    grid-column-end: 2 !important;
}

.new-account__form__check {
    margin-top: var(--space-x2);
    grid-column-start: 1 !important;
    grid-column-end: 3 !important;
}

.new-account__form__submit {
    grid-column-start: 2;
    grid-column-end: 3;
    margin-top: var(--space-x2);
    width: 100%;
}

.new-account-goal {
    max-width: 500px;
    margin: 0 auto;
    padding: var(--space-x2) 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.new-account-goal__yield {
    margin-top: var(--space-and-half);
    font-family: var(--primary-font);
    font-weight: var(--font-extra-bold);
    font-size: 90px;
    line-height: 108px;
    color: var(--secondary-color);
}

.new-account-goal__title {
    margin-top: var(--space-and-half);
    font-family: var(--primary-font);
    font-weight: var(--font-medium);
    font-size: var(--space-and-half);
    line-height: var(--space-x2);
    color: var(--primary-dark-color);
}

.new-account-goal__text {
    margin-top: var(--space-and-half);
    font-family: var(--secondary-font);
    font-weight: var(--font-regular);
    font-size: var(--space);
    line-height: var(--space-and-half);
    color: var(--primary-dark-color);
}

.new-account-goal__go-home {
    margin-top: var(--space-x2);
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/views/login-account/LoginAccountView.styles.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,gCAAgC;IAChC,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,0BAA0B;AAC9B;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;AAC/B;AACA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,gCAAgC;IAChC,mCAAmC;IACnC,eAAe;IACf,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;IACjC,gCAAgC;IAChC,+BAA+B;IAC/B,gCAAgC;IAChC,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,gCAAgC;IAChC,uBAAuB;IACvB,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf","sourcesContent":["\n.new-account {\n    max-width: 500px;\n    margin: 0 auto;\n    padding: var(--space-x2) 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n}\n\n.new-account__title {\n    margin-bottom: var(--space);\n    align-self: flex-start;\n    text-align: left;\n}\n.new-account__text {\n    align-self: flex-start;\n    text-align: left;\n}\n.new-account__subtext {\n    margin-bottom: var(--space-half);\n    letter-spacing: 0.0025em;\n    color: var(--primary-color);\n    font-size: var(--font-small);\n}\n.new-account__methods {\n    width: 100%;\n}\n.new-account__methods.social {\n    display: flex;\n    gap: var(--space-and-half);\n}\n.new-account__methods__method {\n    margin: var(--space-and-half) 0;\n}\n\n.new-account__separator {\n    margin: var(--space-x3) 0;\n    width: 100%;\n}\n\n.new-account__form {\n    margin-top: var(--space-x3);\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: var(--grid-gap);\n}\n.new-account__form .input-field {\n    grid-column-start: 1;\n    grid-column-end: 3;\n}\n\n.new-account__form .checkbox-field {\n    grid-column-start: 1;\n    grid-column-end: 3;\n}\n\n.new-account__form__field-first-half {\n    grid-column-start: 1 !important;\n    grid-column-end: 2 !important;\n}\n\n.new-account__form__check {\n    margin-top: var(--space-x2);\n    grid-column-start: 1 !important;\n    grid-column-end: 3 !important;\n}\n\n.new-account__form__submit {\n    grid-column-start: 2;\n    grid-column-end: 3;\n    margin-top: var(--space-x2);\n    width: 100%;\n}\n\n.new-account-goal {\n    max-width: 500px;\n    margin: 0 auto;\n    padding: var(--space-x2) 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n}\n\n.new-account-goal__yield {\n    margin-top: var(--space-and-half);\n    font-family: var(--primary-font);\n    font-weight: var(--font-extra-bold);\n    font-size: 90px;\n    line-height: 108px;\n    color: var(--secondary-color);\n}\n\n.new-account-goal__title {\n    margin-top: var(--space-and-half);\n    font-family: var(--primary-font);\n    font-weight: var(--font-medium);\n    font-size: var(--space-and-half);\n    line-height: var(--space-x2);\n    color: var(--primary-dark-color);\n}\n\n.new-account-goal__text {\n    margin-top: var(--space-and-half);\n    font-family: var(--secondary-font);\n    font-weight: var(--font-regular);\n    font-size: var(--space);\n    line-height: var(--space-and-half);\n    color: var(--primary-dark-color);\n}\n\n.new-account-goal__go-home {\n    margin-top: var(--space-x2);\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
